/**
 * Button
 */

// Custom
import 'protons';

// Module template
import './_button.twig';

// Import custom sass
import './_button.scss';
import '../../00-protons/printing/_colors.scss';

export const name = 'button';

export function disable() {}

export function enable($context) {
}

export default enable;
